import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export default function CookieConsent() {
  const { t, link } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("dc-consent")) setVisible(true);
  }, []);

  const choose = (val) => {
    localStorage.setItem("dc-consent", val);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 z-[60] mx-auto max-w-xl rounded-2xl border border-white/15 glass-dark p-5 shadow-2xl">
      <p className="text-sm text-white/85 leading-relaxed">
        {t("cookieConsent.text")}{" "}
        <Link to={link("/cookies")} className="text-electric underline underline-offset-2">{t("footer.legal.1.label")}</Link>
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button data-testid="cookie-accept" onClick={() => choose("all")} className="rounded-full bg-gradient-to-r from-dblue to-electric px-5 py-2.5 text-xs font-semibold">
          {t("cookieConsent.accept")}
        </button>
        <button data-testid="cookie-essential" onClick={() => choose("essential")} className="rounded-full border border-white/20 px-5 py-2.5 text-xs font-semibold text-white/80 hover:bg-white/5">
          {t("cookieConsent.essential")}
        </button>
      </div>
    </div>
  );
}
